import { isProductPromotional } from 'investments/common/enums'
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useFetchFixedIncomeProductList } from 'investments/common/hooks'

export function usePromotionalProduct({ accountId }: { accountId: string }) {
  const { data: fixedIncomeProductList } = useFetchFixedIncomeProductList({
    accountId,
    options: { suspense: true }
  })

  const maxInvestAmountLimit = fixedIncomeProductList.reduce((prev, curr) => prev + curr.maxInvestmentAmount, 0)
  const promotionalProduct = fixedIncomeProductList.find(isProductPromotional)
  const defaultProduct = fixedIncomeProductList.find(product => !isProductPromotional(product))
  const hasPromotionalProduct = !!promotionalProduct
  const promotionalTagText = hasPromotionalProduct ? 'Promocional' : ''
  const profitability = promotionalProduct?.apy

  return {
    maxInvestAmountLimit,
    hasPromotionalProduct,
    promotionalTagText,
    profitability,
    promotionalProduct,
    defaultProduct
  }
}
